import apiHelper, { loginApiHelper } from "services/apiHelper";

export const login = (payload, successCallback, setLoading) => {
  return loginApiHelper(`api/user/login`, "post", payload, {});
};

export const changePassword = (oldPassword, newPassword, setMessage) => {
  return apiHelper(
    `/api/user/changepassword/5?oldpassword=${oldPassword}&newpassword=${newPassword}`,
    "post",
    null,
    {}
  )
    .then((res) => {
    })
    .catch((err) => {
      console.error(err);
    });
};
export const mfaEnable = (value, email) => {
  return apiHelper(
    `api/googleauth/mfa_enable?toggel=${value}`,
    "post",
    null,
    {}
  );
};
export const checkAuthenticationCode = (code, email, auth_key) => {
  return apiHelper(
    `api/googleauth/check_authentication_code?a_code=${code}&auth_key=${auth_key}`,
    "post",
    null,
    {}
  );
};
export const checkMfaStatus = (email) => {
  return apiHelper(
    `api/googleauth/check2faStatus?email=${email}`,
    "post",
    null,
    {}
  );
};
